import Persona from "../assets/img/svg/providers/personasIcon.svg";
import Documento from "../assets/img/svg/providers/documento.svg";
import Ubicacion from "../assets/img/svg/providers/ubicacion.svg";

export const itemsProviders = [
  {
    texto: "Proveedores",
    icon: <img src={Persona} alt="Inicio" />,
    url: "/proveedores/todos",
  },
  {
    texto: "Mapa de proveedores",
    icon: <img src={Ubicacion} alt="Inicio" />,
    url: "/proveedores/mapa",
  },
  {
    texto: "Mapa de instaladores",
    icon: <img src={Ubicacion} alt="Inicio" />,
    url: "/proveedores/instaladores/mapa",
  },
  {
    texto: "Documentos Instaladores",
    icon: <img src={Documento} alt="Inicio" />,
    url: "/proveedores/instaladores",
  },
];
